const profileStaffES = {
    header: {
        title: "Perfil del Negocio",
        preview: "Vista previa",
        edit: "Editar",
    },

    images: {
        intro: "Tu primera foto es la portada que ven los clientes.",
        addPhoto: "Agregar foto",
        reviews: "reseñas",
        noPhotos: "Aún no hay fotos",
        needPhoto: "Añade al menos una foto antes de guardar.",
        title: "Imágenes",
        makeCover: "Establecer como portada",
        replace: "Reemplazar",
        delete: "Eliminar",
        cover: "Portada",
        reorderHint: "Mantén presionada una foto y arrástrala para cambiar el orden.",
        noImageSelected: "No hay imagen seleccionada",
        noImage: "No hay imagen",
        confirmDelete: "¿Estás seguro de que quieres eliminar esta imagen?",
        invalidImage: "Ese archivo no es una imagen válida. Elige una foto (JPG, PNG, etc.).",
        tooLarge: "Esa imagen es demasiado grande (más de 20MB). Elige una foto más pequeña.",
        uploadFailed: "No pudimos subir la imagen. Inténtalo de nuevo.",
        cropTitle: "Recortar foto",
        zoom: "Zoom",
    },

    services: {
        intro: "Marca todo lo que estás capacitado para hacer.",
        serviceType: {
            home: "A domicilio",
            online: "Online",
        },
        title: "Servicios",
        add: "+ Agregar",
        empty: "No hay servicios aún.",
        emptyCategory: "Ver o editar servicios",
        name: "Nombre del servicio",
        price: "Precio",
        hours: "Horas",
        minutes: "Minutos",
        description: "Descripción",
        category: "Categoría",
        placeholderName: "Nombre del servicio",
        placeholderDescription: "Descripción del servicio",
        homeService: "A domicilio",
        inShop: "En el local",
        transitTimeLabel: "Tiempo de traslado antes del servicio (minutos)",
        servicesIOffer: "Servicios que ofrezco",
        addServices: "+ Agregar servicios",
        servicesCount: "servicios",
    },

    actions: {
        saveChanges: "Guardar cambios",
        cancel: "Cancelar",
    },

    errors: {
        fillAllFields: "Por favor, completa todos los campos obligatorios.",
    },

    staffInfo: {
        intro: "Tu nombre y biografía tal como los verán los clientes.",
        title: "Editar perfil",
        firstName: "Nombre",
        lastName: "Apellido",
        bio: "Biografía",
        phone: "Teléfono",
    },

    sidebar: {
        editServices: "Editar servicios",
        location: {
            title: "Ubicación",
        },
        contact: {
            title: "Contacto",
            phone: "Teléfono",
            email: "Correo electrónico",
            noPhone: "Teléfono no disponible",
            noEmail: "Correo no disponible",
            socialTitle: "Redes sociales",
            website: "Sitio web",
            instagram: "Instagram",
            facebook: "Facebook",
            tiktok: "TikTok",
        },
        hours: {
            title: "Horario de apertura",
            show: "Mostrar más horarios",
            hide: "Ocultar horarios",
            closed: "Cerrado",
            edit: "Editar horario",
            addHours: "Agregar horario de atención",
        },
        staff: {
            title: "Equipo",
            edit: "Gestionar equipo",
            roles: {
                admin: "Administrador",
                staff: "Empleado",
                owner: "Propietario",
            },
            noStaff: "No hay miembros en el equipo.",
            addStaff: "Invitar miembro",
            remove: "Eliminar",
            editRole: "Cambiar rol",
        },
    },

    modal: {
        shopInfo: {
            title: "Información del negocio",
            subTitle: "Detalles",
            name: "Nombre del negocio",
            description: "Descripción",
            address: "Dirección",
            city: "Ciudad",
            country: "País",
        },
        contact: {
            title: "Información de contacto",
            description: "Actualiza el teléfono, correo y redes sociales.",
        },
        hours: {
            title: "Horario comercial",
            description: "Configura los horarios de apertura y cierre por día.",
            open: "Abre",
            close: "Cierra",
            closed: "Cerrado",
        },
        team: {
            title: "Miembros del equipo",
            description: "Administra los miembros del equipo y sus roles.",
            addButton: "Invitar miembro",
            close: "Cerrar",
            save: "Guardar",
        },
    },

    categories: {
        cannotDeleteWithServices: "Debes eliminar o mover todos los servicios antes de borrar esta categoría",
        addCategory: "Añadir categoría",
        newCategory: "Nueva categoría",
    },

    addAddress: "Agregar dirección",
    addServices: "Editar Servicios",
    addFirstServices:  "Editar Servicios",
    addShopName: "Agregar nombre del local",
    noReviewsyet: "Todavía no hay reseñas",
    addAttributes: "+ Agregar tus atributos",
    addDescription: "Agrega una breve descripción sobre tu negocio",
};

export default profileStaffES;
